import {AlertComponent} from "../../../app/components/alert/AlertComponent";
import React from "react";
import {ThemeColor} from "../../../home/components/homecard/HomeCardComponent";

export function ProblemSetNote({dataStructure}) {
    return (<AlertComponent color={ThemeColor.Secondary}>
        <strong>NOTE:</strong> For the following problems
        <ul>
            <li>I would make sure you know syntax for {dataStructure}s before working through the following
                problems. I would highly recommend you solve these problems <i>outside</i> of IDEs. Most
                interviewers will not let you use autocomplete. You must know syntax off the top of your head.
            </li>
            <li>I would highly recommend you think about time and space complexities for each one as you go. It's
                never too early to start. Just like with algorithms, the more you practice complexity analysis, the
                better you will be.
            </li>
        </ul>
    </AlertComponent>)
}